import './SuggestionGroup.css';
export var suggestionGroupCSS = '_1kewh620-2-0-1';
export var suggestionGroupListCSS = '_1kewh621-2-0-1';